module.exports = __webpack_public_path__ + "static/img/SplashPage.fee70df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/SplashPage.jpg
// module id = F/XA
// module chunks = 44